/* Ovena mobile-lux interactions: page veil, safe prefetch, reveal-on-scroll,
   long-press use-case panels on touch. */
(function(){
  'use strict';
  var d=document;
  var REDUCED=false;
  try{REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}

  /* ---- which URLs are safe to touch without user intent ----
     Shopify serves side-effecting GETs: /cart/<variant>:<qty> adds to cart (and
     applies ?discount=), /account/logout signs the customer out. Those must never
     be prefetched or treated as a plain page navigation, so this is an allowlist
     of read-only content routes, not a blocklist. */
  var SAFE=/^\/(products|collections|pages|blogs)(\/|$)/;
  function internalUrl(a){
    if(!a||a.target&&a.target!=='_self')return null;
    if(a.hasAttribute('download'))return null;
    var href=a.getAttribute('href');
    if(!href||href.charAt(0)==='#')return null;
    var u;try{u=new URL(a.href,location.href);}catch(e){return null;}
    if(u.origin!==location.origin)return null;
    if(u.pathname===location.pathname&&u.hash)return null;
    return u;
  }
  function safeUrl(a){
    var u=internalUrl(a);
    if(!u)return null;
    if(u.pathname!=='/'&&!SAFE.test(u.pathname))return null;
    return u;
  }

  /* ---- veil the white flash between pages ----
     Deliberately does NOT preventDefault or delay navigation, and only arms for
     read-only content links, so a click this script misjudges can never block a
     purchase path. A safety timer lifts the veil if navigation never happens. */
  var veilTimer=null;
  d.addEventListener('click',function(e){
    if(REDUCED||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest&&e.target.closest('a[href]');
    if(!a||!safeUrl(a))return;
    d.body.classList.add('ov-pageout');
    clearTimeout(veilTimer);
    veilTimer=setTimeout(function(){d.body.classList.remove('ov-pageout');},1200);
  },false);
  addEventListener('pageshow',function(e){if(e.persisted)d.body.classList.remove('ov-pageout');});

  /* ---- prefetch read-only pages on first hover/touch ---- */
  var fetched={};
  function prefetch(a){
    var u=safeUrl(a);if(!u)return;
    if(u.search)return;                       /* query strings carry intent (discounts, variants) */
    var k=u.pathname;if(fetched[k]||k===location.pathname)return;fetched[k]=1;
    var l=d.createElement('link');l.rel='prefetch';l.as='document';l.href=u.pathname;
    d.head.appendChild(l);
  }
  d.addEventListener('touchstart',function(e){var a=e.target.closest&&e.target.closest('a[href]');if(a)prefetch(a);},{passive:true});
  d.addEventListener('mouseover',function(e){var a=e.target.closest&&e.target.closest('a[href]');if(a)prefetch(a);});

  /* ---- reveal-on-scroll: below-fold only, with a hard fallback so nothing can
     stay invisible if the observer never fires (hidden ancestor, print, etc.) ---- */
  if(!REDUCED&&'IntersectionObserver' in window){
    var tagged=[];
    var show=function(el){el.classList.add('ov-in');setTimeout(function(){el.classList.remove('ov-io','ov-in');},800);};
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting)return;
        io.unobserve(en.target);show(en.target);
      });
    },{rootMargin:'0px 0px -7% 0px',threshold:0.04});
    var SEL='.ovsg-card,.ovh-card,.ovh-tile,.ovh-dcard,.ovhomefam,.ovtrust-item,.ovh-chip,.ovcw__step,.ovpx-step';
    var tag=function(){
      var nodes=[].filter.call(d.querySelectorAll(SEL),function(el){return !el.dataset.ovIo;});
      var nested=nodes.some(function(el){return el.parentElement&&el.parentElement.closest(SEL);});
      // Keep the original measurement order when a reveal target contains another.
      if(nested){
        nodes.forEach(function(el){
          if(el.dataset.ovIo)return;el.dataset.ovIo='1';
          var r=el.getBoundingClientRect();
          if(r.top>innerHeight*0.92){el.classList.add('ov-io');io.observe(el);tagged.push(el);}
        });
        return;
      }
      // Independent cards can all be measured before any reveal classes are added.
      var below=nodes.map(function(el){return el.getBoundingClientRect().top>innerHeight*0.92;});
      nodes.forEach(function(el,i){
        el.dataset.ovIo='1';
        if(below[i]){el.classList.add('ov-io');io.observe(el);tagged.push(el);}
      });
    };
    if(d.readyState!=='loading')tag();else d.addEventListener('DOMContentLoaded',tag);
    setTimeout(tag,600);
    var revealAll=function(){[].forEach.call(d.querySelectorAll('.ov-io'),show);};
    setTimeout(revealAll,8000);
    addEventListener('beforeprint',revealAll);
    try{matchMedia('print').addListener(function(m){if(m.matches)revealAll();});}catch(e){}
  }

  /* ---- long-press "use it for" panels on touch devices ---- */
  /* (the injected "more below" cue is gone — the PDP template now renders
     a scroll-morph band that serves the same purpose and titles the
     clinical-evidence panel) */

  /* ---- push the chat launcher up instead of hiding or covering it ----
     Shopify Inbox renders <shopify-chat>, whose launcher paints in the browser's
     top layer: from the page you cannot re-stack it (z-index above 2^31 does
     nothing) or move it (a transform on the host moves it zero pixels). What DOES
     work is that its shadow root is OPEN — so we inject one rule into the shadow
     root itself and drive the real button with a variable. The chat stays fully
     functional and simply rides above whatever is occupying the bottom of the
     screen (cookie banner, sticky buy bar), then drops back. */
  var chatEl=null, chatNudge=null, chatRoot=null, chatObserver=null;
  var bottomObserver=null, bottomSizes=null, bottomFrame=0, bottomNeedsScan=false;
  var bottomSeen=new WeakSet();
  var BOTTOM_UI='#ov-consent,#ov-stickybuy,#ovlsb';
  var BUY_UI='.ovp__buy,.ovp__xc,form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"],form[action*="/cart/add"] [name="add"],.shopify-payment-button';
  function queueChat(){
    if(bottomFrame)return;
    bottomFrame=requestAnimationFrame(function(){
      bottomFrame=0;
      if(bottomNeedsScan){bottomNeedsScan=false;observeBottomUI();}
      liftChat();
    });
  }
  function primeChat(){
    if(chatEl&&chatEl.isConnected&&chatNudge&&chatNudge.isConnected)return true;
    var c=d.querySelector('shopify-chat');
    if(!c||!c.shadowRoot)return false;
    if(chatRoot!==c.shadowRoot){
      if(chatObserver)chatObserver.disconnect();
      chatRoot=c.shadowRoot;
      if(window.MutationObserver){chatObserver=new MutationObserver(queueChat);chatObserver.observe(chatRoot,{childList:true,subtree:true});}
    }
    /* .activator-nudge is the PARENT of button.activator — transform only the
       parent, or the button inherits the shift twice and moves double. */
    var nudge=c.shadowRoot.querySelector('.activator-nudge');
    var sel='.activator-nudge';
    if(!nudge){ nudge=c.shadowRoot.querySelector('button.activator'); sel='button.activator'; }
    if(!nudge)return false;
    var s=c.shadowRoot.querySelector('style[data-ov-chat]');
    if(!s){s=d.createElement('style');s.setAttribute('data-ov-chat','1');c.shadowRoot.appendChild(s);}
    /* Apply the offset immediately, so a scrolling purchase button never sits
       under a launcher that is still animating toward its safe position. */
    var css=sel+'{transform:translateY(calc(-1 * var(--ov-chat-lift,0px))) !important;transition:none !important;}'+
      ':host([data-ov-chat-obscured]) '+sel+',:host([data-ov-chat-obscured]) '+sel+' *{visibility:hidden !important;pointer-events:none !important;}';
    if(s.textContent!==css)s.textContent=css;
    if(bottomSizes&&chatNudge&&chatNudge!==nudge)bottomSizes.unobserve(chatNudge);
    chatEl=c; chatNudge=nudge;
    if(bottomSizes)bottomSizes.observe(nudge);
    c.style.setProperty('--ov-chat-lift','0px');
    return true;
  }
  function visibleBox(el){
    if(!el)return null;
    var cs=getComputedStyle(el);
    // Hidden controls cannot collide; avoid measuring their geometry.
    if(cs.display==='none'||cs.visibility==='hidden'||!(parseFloat(cs.opacity||'1')>0.05))return null;
    var r=el.getBoundingClientRect();
    return r.height>4?{style:cs,rect:r}:null;
  }
  function liftChat(){
    if(!primeChat())return;
    if(getComputedStyle(chatEl).display==='none')return;
    var top=Infinity;
    /* anything pinned to the bottom that the launcher must clear */
    ['#ov-consent','#ov-stickybuy','#ovlsb'].forEach(function(sel){
      var el=d.querySelector(sel);
      if(!el)return;
      if(sel==='#ov-stickybuy'&&el.style.transform!=='translateY(0)'&&el.style.transform!=='translateY(0px)')return;
      if(sel==='#ovlsb'&&!el.classList.contains('is-in'))return;
      var box=visibleBox(el);
      if(!box)return;
      // Reserve the full bar height immediately, including while it animates in.
      var inset=parseFloat(box.style.bottom)||0;
      var obstacleTop=sel==='#ov-stickybuy'||sel==='#ovlsb'?innerHeight-inset-el.offsetHeight:box.rect.top;
      top=Math.min(top,obstacleTop);
    });
    /* clear the sticky buy bar by a wider margin, and always sit a little
       above the viewport foot so the launcher never crowds it */
    // Derive the current resting position, rather than caching a prior viewport.
    // Subtract the rendered translation, including an in-progress animation.
    var mobile=matchMedia('(max-width: 820px)').matches;
    var bounds, chatBase, lift=0;
    // Desktop has no control/header collisions: with no bottom obstacle its
    // resting state is already known, so no launcher geometry is needed.
    if(mobile||top!==Infinity){
      var transform=getComputedStyle(chatNudge).transform;
      var shift=transform&&transform!=='none'?new DOMMatrixReadOnly(transform).m42:0;
      bounds=chatNudge.getBoundingClientRect();
      chatBase=bounds.bottom-shift;
      lift=(top===Infinity)?0:Math.max(0,Math.ceil(chatBase-top+12));
    }
    if(mobile){
      /* Main Add to cart, quantity and express checkout can scroll through the
         launcher's resting position before the sticky bar appears. Resolve
         collisions against a candidate resting rectangle, not its last offset,
         so repeated scroll/resize events cannot oscillate or accumulate lift. */
      var controls=[];
      [].forEach.call(d.querySelectorAll(BUY_UI),function(el){
        if(el.closest('#ov-stickybuy,#ovlsb'))return;
        var box=visibleBox(el);
        if(box)controls.push(box.rect);
      });
      for(var pass=0;pass<=controls.length;pass++){
        var previous=lift;
        controls.forEach(function(r){
          var bottom=chatBase-lift, upper=bottom-bounds.height;
          if(r.bottom<=0||r.top>=innerHeight||r.right<=bounds.left||r.left>=bounds.right)return;
          if(bottom+12>r.top&&upper-12<r.bottom)lift=Math.max(lift,Math.ceil(chatBase-r.top+12));
        });
        if(lift===previous)break;
      }
    }
    /* On a very short screen, do not relocate the launcher onto the navigation
       or another purchase control. It returns as soon as there is room. */
    var ceiling=12;
    if(mobile){
      var header=visibleBox(d.querySelector('.ov-header'));
      if(header)ceiling=Math.max(ceiling,header.rect.bottom+12);
    }
    var obscured=mobile&&chatBase-lift-bounds.height<ceiling;
    chatEl.toggleAttribute('data-ov-chat-obscured',obscured);
    if(chatNudge.inert!==obscured)chatNudge.inert=obscured;
    var value=lift+'px';
    if(chatEl.style.getPropertyValue('--ov-chat-lift')!==value)chatEl.style.setProperty('--ov-chat-lift',value);
  }
  function observeBottomUI(){
    [].forEach.call(d.querySelectorAll(BOTTOM_UI+','+BUY_UI),function(el){
      if(bottomSeen.has(el))return;
      bottomSeen.add(el);
      if(bottomObserver)bottomObserver.observe(el,{attributes:true,attributeFilter:['style','class','hidden']});
      if(bottomSizes)bottomSizes.observe(el);
    });
  }
  function watchBottomUI(){
    if(window.ResizeObserver)bottomSizes=new ResizeObserver(queueChat);
    if(window.MutationObserver){
      bottomObserver=new MutationObserver(queueChat);
      /* App widgets and section replacements may arrive after page load. */
      new MutationObserver(function(){bottomNeedsScan=true;queueChat();}).observe(d.body,{childList:true,subtree:true});
    }
    observeBottomUI();
    queueChat();
    addEventListener('scroll',queueChat,{passive:true});
    addEventListener('resize',queueChat,{passive:true});
    addEventListener('pageshow',queueChat);
    if(window.visualViewport){
      window.visualViewport.addEventListener('resize',queueChat,{passive:true});
      window.visualViewport.addEventListener('scroll',queueChat,{passive:true});
    }
    d.addEventListener('transitionend',queueChat);
    d.addEventListener('click',function(){setTimeout(queueChat,80);},true);
    if(window.customElements)customElements.whenDefined('shopify-chat').then(queueChat);
    [400,1200,2500,4000].forEach(function(ms){setTimeout(queueChat,ms);});
  }
  if(d.readyState!=='loading')watchBottomUI();else d.addEventListener('DOMContentLoaded',watchBottomUI);

  var TOUCH=false;
  try{TOUCH=matchMedia('(hover: none)').matches;}catch(e){}
  if(!TOUCH)return;

  /* CSS only un-hides the hint pill once this class lands, so a blocked script
     can never leave "hover over each product" showing on a phone. */
  function ready(){
    d.documentElement.classList.add('ov-mlux-touch');
    [].forEach.call(d.querySelectorAll('.ovshop-hint span:not([class]),.ovcc-hint span:not([class]),.ovwsc-hint span:not([class])'),function(s){
      if(/hover/i.test(s.textContent))s.textContent='Tap a product photo to see what it treats';
    });
    buildSheet();
  }
  if(d.readyState!=='loading')ready();else d.addEventListener('DOMContentLoaded',ready);

  /* ---- use-case bottom sheet ----
     A tap on the product photo opens a sheet from the bottom of the screen. The
     card's own square is far too small on a 2-up phone grid to hold six use
     cases, so the content is lifted out of the card and shown full width, where
     it can breathe and scroll if it needs to. Tapping anywhere else on the card
     still navigates to the product. */
  var sheet,sheetTitle,sheetList,sheetLink,scrim,lastFocus;
  function buildSheet(){
    if(sheet)return;
    scrim=d.createElement('div');scrim.className='ov-ucs-scrim';
    sheet=d.createElement('div');sheet.className='ov-ucs';
    sheet.setAttribute('role','dialog');
    sheet.setAttribute('aria-modal','true');
    sheet.setAttribute('aria-label','What this product is used for');
    sheet.innerHTML='<div class="ov-ucs__grab" aria-hidden="true"></div>'+
      '<h3 class="ov-ucs__title"></h3>'+
      '<p class="ov-ucs__eyebrow">Use it for</p>'+
      '<ul class="ov-ucs__list"></ul>'+
      '<a class="ov-ucs__go" href="#">View product <span aria-hidden="true">&rarr;</span></a>'+
      '<button type="button" class="ov-ucs__close" aria-label="Close">Close</button>';
    d.body.appendChild(scrim);d.body.appendChild(sheet);
    sheetTitle=sheet.querySelector('.ov-ucs__title');
    sheetList=sheet.querySelector('.ov-ucs__list');
    sheetLink=sheet.querySelector('.ov-ucs__go');
    scrim.addEventListener('click',closeSheet);
    sheet.querySelector('.ov-ucs__close').addEventListener('click',closeSheet);
    /* swipe the sheet down to dismiss */
    var y0=null;
    sheet.addEventListener('touchstart',function(e){y0=e.touches[0].clientY;},{passive:true});
    sheet.addEventListener('touchmove',function(e){
      if(y0===null)return;
      var dy=e.touches[0].clientY-y0;
      if(dy>0)sheet.style.transform='translateY('+dy+'px)';
    },{passive:true});
    sheet.addEventListener('touchend',function(e){
      var dy=e.changedTouches[0].clientY-(y0===null?0:y0);
      sheet.style.transform='';
      if(dy>90)closeSheet();
      y0=null;
    },{passive:true});
  }
  function openSheet(card){
    buildSheet();
    var uc=card.querySelector('.ov-uc');if(!uc)return;
    var t=card.querySelector('.ovsg-title,.ovwsc-title,.ovc-title,h3');
    sheetTitle.textContent=t?t.textContent.trim():'';
    sheetList.innerHTML='';
    [].forEach.call(uc.querySelectorAll('li'),function(li){
      var n=d.createElement('li');n.textContent=li.textContent;sheetList.appendChild(n);
    });
    /* card may be the anchor itself (shop grid) or a div wrapping one (wsc grid) */
    var linkEl=(card.tagName==='A')?card:card.querySelector('a[href]');
    var href=linkEl&&linkEl.getAttribute('href');
    if(href)sheetLink.setAttribute('href',href);
    lastFocus=d.activeElement;
    d.body.classList.add('ov-ucs-open');
    if(navigator.vibrate){try{navigator.vibrate(8);}catch(err){}}
    setTimeout(function(){try{sheet.querySelector('.ov-ucs__close').focus();}catch(err){}},60);
  }
  function closeSheet(){
    if(!d.body.classList.contains('ov-ucs-open'))return;
    d.body.classList.remove('ov-ucs-open');
    if(lastFocus&&lastFocus.focus){try{lastFocus.focus();}catch(err){}}
  }
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closeSheet();});


  /* controls that live inside the card anchor and must keep working normally */
  var CTRL='.ovsg-buyrow,.ovsg-add,.ovsg-size,.ovsg-sizechart,.ovwsc-btn,.ovwsc-var,select,button,input,label';
  /* The card is whatever ancestor actually holds the .ov-uc panel. On the shop grid
     that is the <a class="ovsg-card">, but on the wound-skin-care page the panel is a
     SIBLING of the media anchor inside <div class="ovwsc-card"> — the old
     closest('a') check found no panel there, so taps navigated instead of opening
     the sheet. Climb until a containing element owns a panel. */
  function cardOf(t){
    if(!t||!t.closest)return null;
    var el=t.closest('.ovsg-media,.ovwsc-media,.ovc-media');
    while(el&&el!==d.body){
      if(el.querySelector&&el.querySelector('.ov-uc'))return el;
      el=el.parentElement;
    }
    return null;
  }
  /* A light tap on the PHOTO opens the sheet; taps anywhere else on the card
     (title, price, chips) navigate as normal, so the card never feels trapped. */
  d.addEventListener('click',function(e){
    if(!e.target.closest)return;
    if(e.target.closest(CTRL))return;
    if(e.target.closest('.ov-ucs'))return;
    var media=e.target.closest('.ovsg-media,.ovwsc-media,.ovc-media');
    if(!media)return;
    var card=cardOf(e.target);if(!card)return;
    e.preventDefault();e.stopPropagation();
    openSheet(card);
  },true);
})();
